import Utilities from "../../foundation/Utility";

import profile from "../../graphics/profile.svg";

class UserDigest {
    id: number;
    username: string;
    firstName: string;
    lastName: string;
    profilePictureFile: string;

    get fullName(): string {
        return `${this.firstName} ${this.lastName}`;
    }

    constructor(data?: Partial<UserDigest>) {
        Object.assign(this, data);

        if (!this.profilePictureFile)
            this.profilePictureFile = profile;
        else if (this.profilePictureFile !== profile && this.profilePictureFile.indexOf("data:") !== 0) {
            this.profilePictureFile = Utilities.base64ImageToDataUrl(this.profilePictureFile);
        }
    }
}

export default UserDigest;